const PREFIXO = 'BMP.Partner';
const SUFIXO = '.User';

export function simplificaPerfil(perfil) {
  let nome = perfil || '';
  if (nome.startsWith(PREFIXO)) nome = nome.slice(PREFIXO.length);
  if (nome.endsWith(SUFIXO)) nome = nome.slice(0, -SUFIXO.length);
  nome = nome.replace(/^\./, '');

  return nome || 'Basic';
}

export default {
  Basic: 'BMP.Partner.User',
  Manager: 'BMP.Partner.Manager.User',
  Import: 'BMP.Partner.Import.User',
  Report: 'BMP.Partner.Report.User',
  Analista: 'BMP.Partner.Analista.User',
  Gestor: 'BMP.Partner.Gestor.User',
  Master: 'BMP.Partner.Master.User',
  Vendedor: 'BMP.Partner.Vendedor.User',
};